// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"more"},"children":[{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M11.5 4H12.5V5H11.5V4Z M11.5 11.5H12.5V12.5H11.5V11.5Z M11.5 19H12.5V20H11.5V19Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const MoreIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'more',
    ref,
    icon: element,
  },
));

MoreIcon.displayName = 'MoreIcon';

export default MoreIcon;
